export const FAQ_LINKS = {
  addFacebookGroup:
    'https://help.be.live/troubleshooting/how-to-add-the-be-live-app-to-your-facebook-group-1',

  facebookGroupComments: 'https://help.be.live/troubleshooting/facebook-group-comments',

  groupCommentsPermissionPage: '/group-comments',

  grantDevicesPermissions:
    'https://help.be.live/troubleshooting/grant-permissions-for-be-live-to-access-your-camera-mic-and-speakers',

  articles: 'https://help.be.live/',

  faq: 'https://be.live/faq',

  affiliateProgram: 'https://belive.tapfiliate.com',

  tutorials: 'https://www.youtube.com/watch?v=LIEMSlkf6D8&list=PLpTOpxn224h02lqhq4wy-VUlUKgIEdTMi',

  grantPermissionsToBeLive:
    'https://help.be.live/troubleshooting/how-to-allow-pop-ups-to-grant-permissions-for-be-live',

  grantPermissionsOnYoutube:
    'https://help.be.live/troubleshooting/how-to-grant-permissions-on-youtube',

  issuesWithGoingLiveOnFacebook:
    'https://help.be.live/troubleshooting/issues-with-going-live-to-your-facebook-group-or-page',

  tos: 'https://belive.tv/tos',

  privacy: 'https://be.live/privacy',

  blog: 'https://blog.be.live/',

  beliveTVApp: 'https://www.facebook.com/BeLiveTvApp',

  belivers: 'https://www.facebook.com/groups/thebelivers/',

  instagram: 'https://www.instagram.com/belive.tv/',

  linkedin: 'https://www.linkedin.com/company/belive.tv',

  beliveiOSApp: 'https://apps.apple.com/app/be-live/id1524420024',
};
